import React from 'react';
import {
  withSystem,
  Plugins,
  Atom,
  AtomRenderProps,
} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {
  TList,
  TElement,
  TText,
  TRecord,
  TBoolean,
} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const FormBlockLabel = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    innerHTML,
    renderChild,
  }: AtomRenderProps) => {
    return (
      // TODO: fix jsx-a11y lint error
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label {...generateAttributes(attributes, classes)}>
        {/* @ts-expect-error - TS2322 - innerHTML union includes non-ReactNode array types (TODO platform: fix innerHTML type issues) */}
        {innerHTML || getChildren(data).map((child) => renderChild(child))}
      </label>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Field Label',
  constraints: {
    ancestors: [
      {
        is: [
          'FormForm',
          'CommerceAddToCartForm',
          'SearchForm',
          'UserSignUpForm',
          'UserAccountForm',
        ],
        name: 'Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: true,
  render: FormBlockLabel,
  fields: {
    attr: TRecord({
      for: TText,
    }),
    form: TRecord({
      type: withSystem({private: true, defaultValue: 'label'}, TText),
      passwordPage: withSystem({private: true, defaultValue: false}, TBoolean),
    }),
    children: withSystem(
      {
        isBindable: true,
        label: 'Text',
        isLocalizable: true,
      },
      TList(TElement)
    ),
  },
});

export default config;
